import React, { CSSProperties, ReactElement, ReactNode } from "react";
import styles from "./Card.module.css";
import shadowStyles from "../styles/shadow.module.css";

interface Props {
  children: ReactNode;
  style?: CSSProperties;
}

interface CardProps extends Props {
  backgroundColor?: string;
  styleChildren?: CSSProperties;
  shadowStyle?: "small" | "medium" | "none";
}

const shadows = {
  small: shadowStyles.light,
  medium: shadowStyles.medium,
  none: shadowStyles.none,
};

const Card = ({
  style,
  children,
  backgroundColor,
  styleChildren,
  shadowStyle,
}: CardProps): ReactElement => {
  const shadow = shadows[shadowStyle ?? "medium"];
  return (
    <div
      className={`${styles.container} ${shadow}`}
      style={{
        backgroundColor: backgroundColor || "white",
        ...style,
      }}
    >
      <div className={styles.wrapper} style={styleChildren}>
        {children}
      </div>
    </div>
  );
};

export const CardHeader = ({ children, style }: Props): ReactElement => (
  <div className={styles.headerContainer} style={style}>
    {children}
  </div>
);

export const CardBody = ({ children, style }: Props): ReactElement => (
  <div className={styles.bodyContainer} style={style}>
    {children}
  </div>
);

Card.defaultProps = {
  backgroundColor: "white",
};

Card.defaultProps = {
  style: null,
  styleChildren: null,
  shadowStyle: "medium",
};

CardBody.defaultProps = {
  style: null,
};

CardHeader.defaultProps = {
  style: null,
};

export default Card;
